<template>
  <div class="dataAnalysisManagement-page">
    <div class="all-content-container-ad">
      <div id="container" class="map-ad"></div>
    </div>
  </div>
</template>
<script>
import { log } from "util";
export default {
    name: 'dataAnalysisManagement',
  data() {
    return {
      dataList:[]
    };
  },
  mounted() {
   
    this.$forceUpdate()
    this.init();
    this.initMap();
        this.getAreas()
  },
  methods: {
    init() {
      window.addEventListener("touchmove", this.initMap(), { passive: false });
    },
    initMap() {
       
      var map = new BMap.Map("container");
      var point = new BMap.Point(110.404, 33.915);
      map.centerAndZoom(point, 6);
      map.enableScrollWheelZoom();
       var data =[]
       for(var i = 0 ;i <this.dataList.length; i++){
          data.push(new BMap.Point(this.dataList[i].lat, this.dataList[i].ln))
          //data[i].id = "aasasa"
       }
      // var data = [
      //   new BMap.Point(105.297047, 30.979542),
      //   new BMap.Point(116.321768, 39.88748),
      //   ];
   
       // data = this.dataList
         console.log("this.dataList",data)
      var _this=this
      for (var i = 0, len = data.length; i < len; i++) {
        var pt = data[i];
        var myIcon = new BMap.Icon(
          require("@/static/img/dptb.png"),
          new BMap.Size(62, 72)
        );
        var marker = new BMap.Marker(pt, {
          icon: myIcon
        }); // 创建标注
        marker.id =  _this.dataList[i].id 
        marker.addEventListener("click", function(e) {
          console.log(e)
          _this.$router.push({
            name:'regionalMapManagement',
            query:{
              id:e.target.id
            }
          });
        });
        map.addOverlay(marker);
      }
      // 创建小车图标
      // var pt = new BMap.Point(116.417, 39.909);
      // var myIcon = new BMap.Icon(
      //   require("@/static/img/dptb.png"),
      //   new BMap.Size(62, 72)
      // );
      // var marker = new BMap.Marker(pt, {
      //   icon: myIcon
      // }); // 创建标注
      // map.addOverlay(marker); // 将标注添加到地图中
    },
    // 查询所有的区域
    getAreas(){
        this.$api.system
        .getAreas()
        .then((res)=>{
          if(res.code==200){
            for(let i=0;i<res.data.length;i++){
              var obj = {}
              obj.lat = res.data[i].longitude
              obj.ln = res.data[i].dimension
               obj.id=res.data[i].id
               this.dataList.push(obj)
              console.log(this.dataList)
              
           }
           this.init()
          }
        })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/dataAnalysisManagement.scss";
.all-content-container-ad{
  height: calc(100vh - 135px)
}
.map-ad{
  height: 100%;
}
</style>  